<template>
  <div>
    <h3 class="text-white text-lg font-semibold mb-4">Legal</h3>
    <p class="text-sm mb-2">Negociar Tech</p>
    <p class="text-sm mb-4">CNPJ: 31.777.413/0001-00</p>
    <div class="space-y-2 text-sm">
      <button 
        v-for="link in legalLinks" 
        :key="link.id"
        class="block hover:text-white transition-colors"
        @click="openLink(link.id)"
      >
        {{ link.text }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import config from '@/config'
// import { inject } from 'vue'

// const openModal = inject('openModal') as (id: string) => void
const openLink = function(link: string) {
  window.open(config.APP_URL +'/'+ link, "_blank");
}

const legalLinks = [
  { id: 'politicas', text: 'Política de Privacidade' },
  { id: 'termos', text: 'Termos de Uso' }
]
</script>